import { settings, } from '../types'
import HttpService from '../../services/HttpService'

export const updateSettings = fields => {
  return async dispatch => {
    
    dispatch({ type: settings.UPDATE_SETTINGS_ERROR, })

    let storage
    try {
      storage = JSON.parse(localStorage.getItem("user-token"))
    } catch (err) {
      return dispatch({ 
        type: settings.UPDATE_SETTINGS_ERROR, 
        payload: message,
      })
    }
    const payload = {}
    if (fields.firstName) {
      payload.firstName = fields.firstName
    }
    if (fields.lastName) {
      payload.lastName = fields.lastName
    }
    if (fields.email) {
      payload.email = fields.email
    }
    if (fields.dob) {
      payload.dob = fields.dob
    }
    if (fields.password) {
      payload.password = fields.password
    }
    if (fields.passwordConfirmation) {
      payload.passwordConfirmation = fields.passwordConfirmation
    }
    const http = new HttpService()
    await http.patchData(
      '/users/'+storage.data.user.id,
      payload,
      "user-token",
    )
      .then(res => {
        const storagePayload = {
          data: {
            authToken: storage.data.authToken,
            refreshToken: storage.data.refreshToken,
            user: {
              id: res.data.user.id,
              email: res.data.user.email,
              firstName: res.data.user.firstName,
              lastName: res.data.user.lastName,
              isTest: res.data.user.isTest,
              isAdmin: res.data.user.isAdmin,
              dob: res.data.user.dob,
            }
          },
        }
        localStorage.setItem(
          "user-token",
          JSON.stringify(storagePayload),
        )
        dispatch({
          type: settings.UPDATE_SETTINGS_SUCCESS,
        })
      })
      .catch(err => {
        let message
        if ("ERR_NETWORK" === err.code) {
          message = "Server unavailable."
        } else if (err.response?.data?.message) {
          message = err.response.data.message
        } else {
          message = "Something went wrong. Please come back later."
        }
        dispatch({ 
          type: settings.UPDATE_SETTINGS_ERROR, 
          payload: message,
        })
      })
  }
}